import { useMemo } from "react";
import {
  MimaInput,
  MimaMultiDropdown,
  MimaPaginatedDropdown,
  MimaTagInput,
  MimaText,
  ReceiptCheckBox as RCB,
  ReactQuillInput,
} from "../../components";
import { fashCreativeStore } from "../../stores";

const StyleStep1 = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  setFilterQuery,
}) => {
  const collections = fashCreativeStore?.collections;

  const collectionsData = useMemo(() => {
    return collections.map((x) => ({
      key: x.key,
      value: x.name,
    }));
  }, [collections]);

  const collectionSuggestion = useMemo(() => {
    return collections.map((x) => ({
      a: x.name,
    }));
  }, [collections]);

  return (
    <>
      <MimaInput
        labelTitle="Style Name"
        placeholder="Enter Style Name"
        id="name"
        name="name"
        value={values.name}
        onChange={(e) => {
          handleChange(e);
          setFieldValue(`variations.0.name`, e.target.value);
        }}
        onBlur={handleBlur}
        error={errors.name}
        touched={touched.name}
        mb={2}
      />

      <div style={{ marginBottom: "2rem" }}>
        <MimaText variant="small" mb={1}>
          Are you Migrating for a Fash User?
        </MimaText>
        <div className="modal__beside">
          <RCB
            title="Yes"
            onChange={() => {
              setFieldValue("isMigration", true);
            }}
            checked={values.isMigration}
            value={values.isMigration}
            name="isMigration"
          />
          <RCB
            title="No"
            onChange={() => {
              setFieldValue("isMigration", false);
            }}
            checked={!values.isMigration}
            value={!values.isMigration}
            name="isMigration"
          />
        </div>
        {errors.isMigration ? (
          <MimaText variant="small" color="var(--color-error)">
            {""}
            {touched.isMigration && errors.isMigration}
            {""}
          </MimaText>
        ) : null}
      </div>

      {values.isMigration ? (
        <MimaPaginatedDropdown
          type="text"
          name="Designer"
          id="Designer"
          value={values.designerName}
          queryKey={["getAllSignedBusinesses"]}
          optionLabel="tradingName"
          labelTitle="Select business"
          placeholder="Select business"
          touched={touched?.business}
          error={errors?.business}
          url="/businesses"
          getPageValue={(page) => page?.data?.businesses || []}
          getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
          onChange={(data) => {
            setFieldValue("business", data._id);
            setFieldValue("designerName", data.tradingName);
            setFilterQuery(data._id);
          }}
          width={38}
        />
      ) : (
        <MimaInput
          labelTitle="Designer"
          placeholder="Enter Name of Designer"
          id="designerName"
          name="designerName"
          value={values.designerName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.designerName}
          touched={touched.designerName}
        />
      )}

      {values.isMigration ? (
        <>
          <div style={{ marginBottom: "2rem" }}>
            <MimaText variant="small" mb={1} mt={1}>
              Product Type
            </MimaText>
            <div className="modal__beside__grid">
              <RCB
                title="Product"
                onChange={() => {
                  setFieldValue("type", "PRODUCT");
                }}
                checked={values.type === "PRODUCT"}
                value={"PRODUCT"}
                name="type"
              />
              <RCB
                title="Service"
                onChange={() => {
                  setFieldValue("type", "SERVICE");
                }}
                checked={values.type === "SERVICE"}
                value={"SERVICE"}
                name="type"
              />
            </div>
          </div>
          <div style={{ marginBottom: "2rem" }}>
            <MimaText variant="small" mb={1} mt={1}>
              Set as best selling
            </MimaText>
            <div className="modal__beside">
              <RCB
                title="Yes"
                onChange={() => {
                  setFieldValue("bestSelling", true);
                }}
                checked={values.bestSelling}
                value={values.bestSelling}
                name="bestSelling"
              />
              <RCB
                title="No"
                onChange={() => {
                  setFieldValue("bestSelling", false);
                }}
                checked={!values.bestSelling}
                value={!values.bestSelling}
                name="bestSelling"
              />
            </div>
          </div>
          <div style={{ marginBottom: "2rem" }}>
            <MimaText variant="small" mb={1} mt={1}>
              Set as out of stock
            </MimaText>
            <div className="modal__beside">
              <RCB
                title="Yes"
                onChange={() => {
                  setFieldValue("isSoldOut", true);
                }}
                checked={values.isSoldOut}
                value={values.isSoldOut}
                name="isSoldOut"
              />
              <RCB
                title="No"
                onChange={() => {
                  setFieldValue("isSoldOut", false);
                }}
                checked={!values.isSoldOut}
                value={!values.isSoldOut}
                name="isSoldOut"
              />
            </div>
          </div>
          <div style={{ marginBottom: "2rem" }}>
            <MimaText variant="small" mb={1} mt={1}>
              Pin Style To Top
            </MimaText>
            <div className="modal__beside">
              <RCB
                title="Yes"
                onChange={() => {
                  setFieldValue("topView", true);
                }}
                checked={values.topView}
                value={values.topView}
                name="topView"
              />
              <RCB
                title="No"
                onChange={() => {
                  setFieldValue("topView", false);
                }}
                checked={!values.topView}
                value={!values.topView}
                name="topView"
              />
            </div>
          </div>
          <div style={{ marginBottom: "2rem" }}>
            <MimaText variant="small" mb={1}>
              Do You Want To Create New Collection ?
            </MimaText>
            <div className="modal__beside">
              <RCB
                title="Yes"
                onChange={() => {
                  setFieldValue("createCollections", true);
                }}
                checked={values.createCollections}
                value={values.createCollections}
                name="createCollections"
              />
              <RCB
                title="No"
                onChange={() => {
                  setFieldValue("createCollections", false);
                }}
                checked={!values.createCollections}
                value={!values.createCollections}
                name="createCollections"
              />
            </div>
            {errors.createCollections ? (
              <MimaText variant="small" color="var(--color-error)">
                {""}
                {touched.createCollections && errors.createCollections}
                {""}
              </MimaText>
            ) : null}

            {!values.createCollections ? (
              <>
                <MimaMultiDropdown
                  labelTitle="Style Collection"
                  name="styleCollections"
                  id="styleCollections"
                  value={values.styleCollections}
                  placeholder="Select Collection"
                  currentValue={values.styleCollections}
                  onChange={(data) => {
                    setFieldValue("styleCollections", data);
                  }}
                  data={collectionsData}
                  touched={touched.styleCollections}
                  error={errors.styleCollections}
                  mt={2}
                />
              </>
            ) : (
              <MimaTagInput
                placeholder="Style Collection"
                labelTitle="Enter New Collection"
                tags={values.newCollections}
                setTags={(item) => {
                  setFieldValue("newCollections", item);
                }}
                name="newCollections"
                onBlur={handleBlur}
                error={errors.newCollections}
                touched={touched.newCollections}
                width={38}
                mt={2}
                suggestionData={collectionSuggestion}
                handleFilter={(item, text) => {
                  return item?.a?.toLowerCase()?.includes(text);
                }}
              />
            )}
          </div>
        </>
      ) : (
        ""
      )}

      <div style={{ marginBottom: "2rem" }}>
        <MimaText variant="small">Gender</MimaText>
        <div className="modal__beside">
          <RCB
            title="Male"
            onChange={() => {
              setFieldValue("gender", "MALE");
            }}
            checked={values.gender === "MALE"}
            value="MALE"
            name="gender"
          />
          <RCB
            title="Female"
            onChange={() => setFieldValue("gender", "FEMALE")}
            checked={values.gender === "FEMALE"}
            value="FEMALE"
            name="gender"
          />
          <RCB
            title="Unisex"
            onChange={() => setFieldValue("gender", "UNISEX")}
            checked={values.gender === "UNISEX"}
            value="UNISEX"
            name="gender"
          />
        </div>
        {errors.gender ? (
          <MimaText variant="small" color="var(--color-error)" mt={1}>
            {""}
            {touched.gender && errors.gender}
            {""}
          </MimaText>
        ) : null}
        <ReactQuillInput
          name="description"
          labelTitle="Description"
          error={errors.description}
          touched={touched.description}
          placeholder="Enter description"
          width={38}
          mt={2}
          mb={2}
        />
      </div>
    </>
  );
};

export default StyleStep1;
